module.exports = __webpack_public_path__ + "img/chesscom.3a95657d.svg";